import Service from "../Service";
let user = {
  username: "kuntinan.p@kisracorp.com",
  password: "x4*mka!F!pKYvf6B",
};

const webdata = {
  getAboutPage() {
    return Service.get(`/api/frontend/about`);
  },
  getArticles(params) {
    let query = "";
    if (params) {
      var esc = encodeURIComponent;
      query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");
    }
    return Service.get(`/api/frontend/article/all?` + query);
  },
  getArticlesWithParams(params) {
    return Service.get(`/api/frontend/article/all`, {
      params: params,
    });
  },
  getArticlesMode(mode, industry) {
    let industry_id = industry ? industry : null;
    if (mode === "data-and-stats") {
      return Service.get(
        `/api/frontend/article/all?mode_page=${mode}&industry_id=${industry_id}`
      );
    }
    return Service.get(`/api/frontend/article/all?mode_page=${mode}`);
  },
  getArticleDetail(id) {
    return Service.get(`/api/frontend/article/detail?article_id=` + id);
  },
  getMainMenu() {
    return Service.get(`/api/frontend/main-menu`);
  },
  getFirstMenu() {
    return Service.get(`/api/frontend/first-menu`);
  },
};

export default webdata;
